<template>
  <div class="contair">
    <div class="content">
      <div class="logoImg">
        <img src="../../assets/images/logo.png" />
      </div>
      <div class="inputContair">
        <div class="titleText">
          <p>用户登录</p>
          <!-- <p>天算 v2019.08.24</p> -->
        </div>
        <div v-if="isShowCode">
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item prop="nickname">
              <el-input type="text" @keyup.enter.native="submitForm('ruleForm')" v-model="ruleForm.nickname"
                autocomplete="off" placeholder="用户名"></el-input>
              <i class="iconfont icon-shouji"></i>
            </el-form-item>
            <el-form-item prop="pass">
              <el-input type="password" @keyup.enter.native="submitForm('ruleForm')" v-model="ruleForm.pass"
                autocomplete="off" placeholder="密码"></el-input>
              <i class="iconfont icon-mima"></i>
            </el-form-item>
            <!-- <el-form-item prop="verificate" class="verificate">
              <el-input type="text" @keyup.enter.native="submitForm('ruleForm')" v-model="ruleForm.verificate"
                autocomplete="off" placeholder="图形验证码" class="codeBox"></el-input>
              <i class="iconfont icon-iconfront-"></i>
              <div class="verification" @click="refreshCode()">
                <SIdentify :identifyCode="identifyCode"></SIdentify>
              </div>
            </el-form-item> -->
            <div class="choiceBox">
              <el-select v-model="value">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <div class="forget">
                <span>
                  <router-link to="/forgetPass" class="findPass">忘记密码？</router-link>
                  <!-- <router-link :to="{name:'historyRecordId',params: {id:radio}}" class="findPass">忘记密码？</router-link> -->
                </span>
              </div>
            </div>
            <el-form-item class="register">
              <el-button type="primary" @click="submitForm('ruleForm')" class="registerButton">登录</el-button>
            </el-form-item>
          </el-form>
          <div class="otherLogin">
            <!-- <p class="chat"><span @click="showCode()">游客登陆</span></p> -->
           <p class="chat">
          <!--   <span @click="touristLogin()" class="chat" style="text-decoration:underline">游客登陆</span> -->
            </p> 
            <p class="login">
              <span>
                <router-link to="/userRegistration" class="resistrate">注册账号</router-link>
              </span>
            </p>
          </div>
        </div>
        <div v-else class="loginCode">
          <img src="../../assets/images/chatCode.jpg" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SIdentify from './identify'
import qs from 'qs'
export default ({
  name: 'userLogin',
  components: {
    SIdentify
  },
  data() {
    var checkNickname = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    // var checkVerificate = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请输入验证码'));
    //   } else if (value !== this.identifyCode) {
    //     callback(new Error('验证码错误'));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      ruleForm: {
        nickname: '',
        pass: '',
        verificate: ''
      },
      isShowCode: true,
      isdisabled: true,
      identifyCodes: '1234567890',
      identifyCode: '1234',
      options: [{
        value: '选项1',
        label: '不记住密码'
      }, {
        value: '选项2',
        label: '三天内自动登录'
      }, {
        value: '选项3',
        label: '一周内自动登录'
      }, {
        value: '选项4',
        label: '一月内自动登录'
      }],
      value: '不记住密码',
      rules: {
        pass: [{
          validator: validatePass,
          trigger: 'blur'
        }],
        nickname: [{
          validator: checkNickname,
          trigger: 'blur'
        }]
        // ,
        // verificate: [{
        //   validator: checkVerificate,
        //   trigger: 'blur'
        // }]
      },
    }
  },
  // created: function() { //登录后的状态数据 ，前台手动加，后台联调后删除这个方法
  //   this.refreshCode();//刷新验证码
  // },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login();
        } else {
          return false;
        }
      });
    },
    submitForgetForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    refreshCode() {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ]
      }
    },
    agreeTreaty() {
      if (this.isdisabled == true) {
        this.isdisabled = false;
      } else {
        this.isdisabled = true;
      }
    },
    showCode() {
      this.isShowCode = false;
    },

    // 游客登陆
    touristLogin() {
      this.ruleForm.nickname = '13618262673'
      this.ruleForm.pass = 'sjhg1234'
      this.login();
    },

    login() {
      let _this = this;
      var data_ = {
        "userType": this.$store.state.defaultUserType,
        "loginMode": "0",
        "client": this.$store.state.defaultClient,
        "clientSys": this.$store.state.defaultClientSys,
        "systemcode": this.$store.state.systemcode //系统编号
      };
      data_.loginName = _this.ruleForm.nickname;
      data_.password = _this.ruleForm.pass;
      var selected = _this.value;
      var expiredatelength = ''; //validTime token有效期，单位分钟
      if ('选项1' === selected) {
        //不记住密码
      } else if ('选项2' === selected) {
        //三天内自动登录
        expiredatelength = "4320";
      } else if ('选项3' === selected) {
        //一周内自动登录
        expiredatelength = "10080";
      } else if ('选项4' === selected) {
        //一月内自动登录默认30天
        expiredatelength = "43200";
      }
      if (expiredatelength) {
        data_.validTime = expiredatelength;
      }
      let paramdata = {};
      paramdata.url = "/jwt/token/login";
      paramdata.data = data_; //json对象
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          var userInfo = res.data.result.userInfo;
          userInfo.token = res.data.result.token;
          //勾选了一段时间内自动登录
          if (expiredatelength) {
            userInfo.autoLogin = true;
          } else {
            userInfo.autoLogin = false;
          }
          // 将用户token保存到vuex中
          _this.$store.commit('LOGIN', userInfo);
          //登录成功(路由中有params.redirect_url有值跳转,无值返回首页 )
          if (_this.$route.params.redirect_url) {
            _this.$router.replace({
              path: _this.$route.params.redirect_url
            })
          } else {
            _this.$router.push("/");
          }
        } else {
          _this.$alert('登陆失败原因:' + res.data.errmsg, '登陆提示', {
            confirmButtonText: '确定',
            callback: action => { }
          });
        }
      };
      paramdata.onFailed = function (res) {
        console.log(res);
      };
      _this.$axiosUtil.postServer(paramdata);
    }
  }
})
</script>
<style lang="scss" scoped>
.contair {
  width: 100%;
  height: 100%;
  background: #252B3A;
}

.content {
  width: 1280px;
  margin: 0px auto;
  background: #252B3A;
}

.logoImg {
  margin: 0px auto;
  background: #252B3A;
  padding-top: 100px;
  width: 100px;
  padding-bottom: 20px;
}

.logoImg>img {
  background: #252B3A;
  width: 100px;
}

.inputContair {
  margin: 0px auto;
  padding: 20px 30px;
  /* background: #4d587359; */
  background: rgba(77, 88, 115, 0.35);
  width: 460px;
}

.titleText {
  color: #ffffff;
  text-align: center;
  padding-bottom: 10px;
}

.titleText>p:first-of-type {
  font-size: 36px;
  margin: 0px;
  line-height: 40px;
}

.titleText>p:last-of-type {
  font-size: 14px;
  margin: 0px;
  line-height: 20px;
}

.el-form-item__label {
  color: #ffffff;
}

>>>.el-form-item__content {
  margin-left: 30px !important;
  display: flex;
}

>>>.el-input__inner {
  width: 400px;
  border-radius: $border-radius;
  padding-left: 25px;
}

.verificate {
  display: flex;
}

.codeBox {
  width: 260px;
  margin-right: 10px;
  margin-right: 10px;
}

>>>.codeBox>.el-input__inner {
  width: 260px
}

.verification {
  height: 40px;
  text-align: center;
  background: #ffffff;
  margin-left: 10px;
}

.verification>p {
  margin: 0px;
  line-height: 40px;
  font-size: 16px;
}

.agreeBox {
  color: #ffffff;
  padding-left: 30px;
}

.register {
  margin-top: 20px;
}

>>>.register .el-form-item__content {
  width: 400px;
}

.register button {
  width: 400px;
  background: $color-primary;
  color: #ffffff;
  border: 1px solid $color-primary;
}

.register button:hover {
  background: $color-primary-light-1;
}

>>>.el-input__icon {
  line-height: 35px;
}

.otherLogin {
  display: flex;
  color: #ffffff;
  padding: 0px 30px;
}

.otherLogin>p:first-of-type {
  text-align: left;
  width: 50%;
}

.otherLogin>p:last-of-type {
  text-align: right;
  width: 50%;
}

.icon-weixin {
  color: #1afa29;
  background: #ffffff;
  border-radius: 50%;
  vertical-align: 0;
}

.icon-shouji,
.icon-iconfront-,
.icon-mima,
.icon-nicheng {
  position: absolute;
  top: 0px;
  left: 5px;
  font-size: 16px;
  color: #CCCCCC;
  height: 40px;
  width: auto;
  line-height: 40px;
}

.chat>span,
.loginWay,
.login:hover {
  cursor: pointer;
}

.choiceBox {
  display: flex;
}

>>>.el-select {
  margin-left: 30px;
}

>>>.choiceBox .el-input__inner {
  width: 180px !important;
  height: 30px;
}

.forget {
  width: 220px;
  text-align: right;
  color: #ffffff;
}

.forget>span {
  margin: 0px;
  font-size: 14px;
  line-height: 30px;
}

.forget>span:hover {
  cursor: pointer;
}

>>>.el-select-dropdown__item {
  height: 25px !important;
  line-height: 25px !important;
}

.box {
  width: 100%;
  height: 100%;
}

.verificate {
  display: flex;
}

.codeBox {
  width: 250px;
  margin-right: 10px;
}

>>>.codeBox>.el-input__inner {
  width: 250px
}

.verificat {
  width: 140px;
  height: 40px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #DCDFE6;
}

.verificat>p {
  margin: 0px;
  line-height: 40px;
  font-size: 16px;
}

.loginWay {
  font-size: 16px;
  color: #ffffff;
  text-align: right;
  padding-right: 30px;
}

.findPass {
  color: #ffffff;
  font-size: 16px;
}

.resistrate {
  font-size: 16px;
  color: #ffffff;
}

.loginCode {
  margin: 0px auto;
  width: 400px;
  height: 400px;
}

.loginCode>img {
  background: #252B3A;
  width: 400px;
  height: 400px;
}

>>>.el-button {
  font-size: 18px;
  border-radius: $border-radius;
}
</style>



// WEBPACK FOOTER //
// src/page/memberCenter/userLogin.vue